import { OperationResult } from '@vp/common/core/OperationResult';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';
import { ProfileThemeModel } from '@vp/profile/core/model/ProfileThemeModel';

export abstract class ThemingManagerRepository {
  abstract update(profileId: string, theme: ProfileThemeModel, controller?: AbortController): Promise<OperationResult<ProfileModel>>;
}
